import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './LinkHeading.css';

const LinkHeading = ({ size, children, href, ...rest }) => {
  const cx = classnames.bind(styles);
  const linkClasses = cx('link', size);

  return (
    <a className={linkClasses} href={href} {...rest}>
      {children}
    </a>
  );
};

LinkHeading.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  size: PropTypes.string
};

LinkHeading.defaultProps = { href: '#' };

LinkHeading.displayName = 'LinkHeading';

export default LinkHeading;



// WEBPACK FOOTER //
// ./src/uis/elements/Link/LinkHeading/LinkHeading.js